import { render, staticRenderFns } from "./ReferralsConfirmation.vue?vue&type=template&id=2ec9deb8"
import script from "./ReferralsConfirmation.vue?vue&type=script&lang=js"
export * from "./ReferralsConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports